import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import { useWindowScrollDirection } from '../../../hooks/useWindowScrollDirection';
import ShareLink from '../../ShareLink';
import { IconPlus } from '../../Icon/IconPlus';
import { IconClose } from '../../Icon/IconClose';
import { conf } from '../../../domain/services/configService';
import { breakpointService } from '../../../domain/services/breakpointService';
import { theme } from '../../../domain/theme';

export const ShareKitDesktop = ({
  isOpen,
  url,
  title,
  gtmData,
  color,
  openStateHandler,
  position,
  useBrowserUrl
}) => {
  const { y: directionY } = useWindowScrollDirection();
  const isGoingUp = directionY !== 'down';
  const [isForceVisible, setIsForceVisible] = useState(false);
  const setVisible = () => {
    setIsForceVisible(true);
  };
  useEffect(() => {
    document.addEventListener('gatsbyOnRouteUpdate', setVisible, {
      passive: true
    });
    return () => {
      document.removeEventListener('gatsbyOnRouteUpdate', setVisible, {
        passive: true
      });
    };
  }, []);
  useEffect(() => {
    let timeoutId;
    if (isForceVisible) {
      timeoutId = setTimeout(() => setIsForceVisible(false), 3000);
    }
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [isForceVisible]);

  const isVisible = isForceVisible || isGoingUp;

  const StyleShareLinkPlus = css`
    border: none;
    border-left: solid 1px #dadada;
    background: none;
    height: 30px;
    width: 30px;
    padding-left: 10px;
    margin-bottom: 13px;
    &:focus {
      outline: none;
    }
    ${theme.mq.small_desktop} {
      padding-top: 10px;
      padding-left: 0;
      border-top: solid 1px #dadada;
      border-left: unset;
      margin-bottom: unset;
    }
    display: flex;
    justify-content: center;
    svg {
      display: block;
      width: 20px;
      overflow: auto;
      path {
        display: block;
        transition: all 300ms ease-in-out;
      }
      &:hover {
        fill: #fc0;
        stroke: #fc0;
        path {
          stroke: #fc0;
        }
      }
    }
  `;
  const styleShareKitContainer = css`
    display: flex;
    flex-direction: row;
    position: fixed;
    bottom: 0;
    right: ${isVisible ? 0 : -217}px;
    background: white;
    z-index: 100000;
    transition: all 0.35s ease;
    height: 40px;
    width: auto;
    padding: 10px 10px 0;
    align-items: center;
    border: solid 1px #dadada;
    ${theme.mq.small_desktop} {
      padding: 10px 0;
      width: 40px;
      height: auto;
      flex-direction: column;
      position: fixed;
      top: ${position};
      left: ${isVisible ? 0 : -40}px;
      right: unset;
      bottom: unset;
    }
    > a {
      display: none;
    }
    ${isOpen
      ? ` > a {
        display: block;
      }`
      : `a:nth-of-type(-n+3) {
        display: block;
    }`}
  `;

  return (
    <div css={styleShareKitContainer}>
      <ShareLink
        type="facebook"
        url={url}
        title={title}
        gtmData={gtmData}
        color={color}
        useBrowserUrl={useBrowserUrl}
      />
      <ShareLink
        type="twitter"
        url={url}
        title={title}
        via={conf.menus.menuSocialMedia.twitterHandle}
        gtmData={gtmData}
        color={color}
        useBrowserUrl={useBrowserUrl}
      />
      <ShareLink
        type="whatsapp"
        url={url}
        mobile={breakpointService.isMobile()}
        title={title}
        gtmData={gtmData}
        color={color}
        useBrowserUrl={useBrowserUrl}
      />
      <ShareLink
        type="flipboard"
        url={url}
        title={title}
        gtmData={gtmData}
        color={color}
        useBrowserUrl={useBrowserUrl}
      />

      <ShareLink
        type="email"
        url={url}
        title={title}
        gtmData={gtmData}
        color={color}
        useBrowserUrl={useBrowserUrl}
      />
      <button css={StyleShareLinkPlus} type="button" onClick={openStateHandler}>
        {isOpen ? (
          <IconClose color={color} size={20} />
        ) : (
          <IconPlus color={color} size={20} />
        )}
      </button>
    </div>
  );
};

ShareKitDesktop.defaultProps = {
  gtmData: [],
  color: undefined,
  isOpen: false,
  position: '50%',
  useBrowserUrl: false
};
ShareKitDesktop.propTypes = {
  url: PropTypes.string.isRequired,
  gtmData: PropTypes.arrayOf(
    PropTypes.shape({
      var: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })
  ),
  color: PropTypes.string,
  title: PropTypes.string.isRequired,
  isOpen: PropTypes.bool,
  openStateHandler: PropTypes.func.isRequired,
  position: PropTypes.string,
  useBrowserUrl: PropTypes.bool
};
